<template>
  <div
    class="
      toast-notify
      p-1
      left-4
      gap-1
      bg-easy-grey
      rounded-xl
      border-2 border-easy-grey
      hover:border-yellow
      z-20
    "
    :style="{ top: `${6 + latecomersAmount * 3}rem` }"
  >
    <span class="text-sm flex items-center pr-4">
      <ViceStethoscope class="w-11 h-11" pathFill="#0F766E" />
      Would you like to
      <span class="font-semibold text-vice-teal-900">&nbsp;add stethoscope&nbsp;</span>
      to the session?
    </span>
    <button
      @click="handleStethoscopeConnection(true)"
      class="
        p-1
        text-xs
        font-semibold
        text-vice-teal-700
        border-light-green
        rounded-md
        border-2
        hover:border-vice-teal-600
        hover:bg-vice-teal-100
      "
    >
      CONNECT
    </button>
    <button @click="closeToast">
      <CrossSimpleIcon type="link" class="text-vice-dark-grey hover:text-strong-grey" />
    </button>
  </div>
</template>

<script>
import { onMounted, onUnmounted } from 'vue';
import CrossSimpleIcon from '@/Components/Icons/CrossSimpleIcon.vue';
import ViceStethoscope from '@/Components/Icons/ViceStethoscope.vue';
import useSessionStore from '@/Stores/useSessionStore';

export default {
  components: { ViceStethoscope, CrossSimpleIcon },
  emits: ['stethoscopeConnectionAllowed', 'toggleToast', 'audioNotification'],
  props: {
    showToast: {
      type: Boolean,
      default: true,
    },
    latecomersAmount: {
      type: Number,
    },
  },
  setup(props, { emit }) {
    const sessionStore = useSessionStore();

    const handleStethoscopeConnection = (accepted) =>
      emit('stethoscopeConnectionAllowed', !!accepted);

    const closeToast = () => emit('toggleToast');

    onMounted(() => {
      emit('audioNotification');
      sessionStore.toastCount += 1;
    });

    onUnmounted(() => {
      sessionStore.toastCount -= 1;
    });

    return { handleStethoscopeConnection, closeToast };
  },
};
</script>
<style scoped></style>
